import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const AddToBardNotifCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  const content = rtl
    ? `تمت إضافتك الى قائمة أعضاء مجلس الادارة`
    : `You have been added to the board members`
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={content}
    />
  )
}

export default AddToBardNotifCover
